// pages/Dashboard.jsx
import SearchPage from "../../components/home/SearchPage";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <SearchPage />
    </HomeLayout>
  );
}
